import React from "react";
import { useSelector } from "react-redux";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";

export const Dropdown = ({ title, slice: key, allOptions, selectedOptions, onOptionsChange }) => {
  const pendingFilters = useSelector((state) => state.locations.pendingFilters);
  const isLoading = pendingFilters.includes(key);

  return (
    <div className="filter">
      <p>{title}</p>
      {isLoading ? (
        <button className="picky__input">
          <LoadingAnimation uiLoader />
        </button>
      ) : (
        <MultiSelectDropdown
          options={allOptions}
          selectedFilters={selectedOptions}
          placeholder="0 selected"
          numberDisplayed={0}
          includeSelectAll
          enableOnly
          moduleName="Locations Selector"
          onSelectChange={onOptionsChange}
        />
      )}
    </div>
  );
};
